<!-- App Page not found component -->
<script>
export default {
  name: "app-page-not-found"
};
</script>

<!-- Template -->
<template>
  <h2 class="page-not-found">Page not found</h2>
</template>


